import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

function CmsIconTabNav({ tabs, activeId, basePath }) {
  return (
    <nav className="cms-website-tabs-nav" aria-label="Website CMS sections">
      <ul className="cms-website-tabs-list">
        {tabs.map((tab) => {
          const isActive = activeId === tab.id;
          return (
            <li key={tab.id} className={classnames("cms-website-tabs-list__item", { "is-active": isActive })}>
              <Link
                to={`${basePath}/${tab.id}`}
                className={classnames("cms-website-tab-link", { "is-active": isActive })}
                title={tab.description ? `${tab.label} — ${tab.description}` : tab.label}
                aria-current={isActive ? "page" : undefined}
              >
                <span className="cms-website-tab-link__icon-wrap">
                  <img src={tab.image} alt="" className="cms-tab-icon-img" />
                </span>
                <span className="cms-website-tab-link__text">
                  <span className="cms-tab-title">{tab.label}</span>
                  {tab.description && (
                    <span className="cms-tab-sublabel">{tab.description}</span>
                  )}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default CmsIconTabNav;
